import definitions from "./definitions";
import operators from "./operators";
/*
category: friendlyName of table
table: actual table name
fullTableName: incase if i need to send this when switching between modes to prepopulate the fields
column: actually name of column used for fields with no filters
friendlyName: used for fields and filters
translation: translates the filter into plain english
queryBuilderJSON: filter rules
distinctValueJSON: this will fire 
*/
const version = "1.0";
const globalLimit = 1000;
const db = "IUSM-GEMMS";
const dbType = "Snowflake";
const patientTableName = "DH_CRC_IUMED.IUMED_DBO_PATIENT";

const data = {
  version,
  globalLimit,
  db,
  patientTableName,
  getDistinctCptCodes: (phrase = null) => {
    return {
      dbType,
      referenceTable: true,
      autoComplete: phrase ? true : false,
      autoCompletePhrase: phrase,
      limit: globalLimit,
      name: "getDistinctColumnValues",
      columnNames: [
        {
          columnName: "COMMON.PUBLIC.CPT.CPT_CODE",
        },
        {
          columnName: "COMMON.PUBLIC.CPT.CPT_DESCRIPTION",
        },
      ],
    };
  },
  getDistinctIcd9Codes: (phrase = null) => {
    return {
      dbType,
      referenceTable: true,
      autoComplete: phrase ? true : false,
      autoCompletePhrase: phrase,
      limit: globalLimit,
      name: "getDistinctColumnValues",
      columnNames: [
        {
          columnName: "COMMON.PUBLIC.ICD9.CODE",
        },
        {
          columnName: "COMMON.PUBLIC.ICD9.SHORT_DESCRIPTION",
        },
        {
          columnName: "COMMON.PUBLIC.ICD9.DESCRIPTION",
        },
      ],
    };
  },
  getDistinctIcd10Codes: (phrase = null) => {
    return {
      dbType,
      referenceTable: true,
      autoComplete: phrase ? true : false,
      autoCompletePhrase: phrase,
      limit: globalLimit,
      name: "getDistinctColumnValues",
      columnNames: [
        {
          columnName: "COMMON.PUBLIC.ICD10.ICD_10_CODE",
        },
        {
          columnName: "COMMON.PUBLIC.ICD10.SHORT_DESCRIPTION",
        },
        {
          columnName: "COMMON.PUBLIC.ICD10.LONG_DESCRIPTION",
        },
      ],
    };
  },
  queryItems: [
    {
      category: "Allergy History",
      table: "ALLERGY_DESCRIPTION",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY",
      friendlyName: "Allergy",
      key: "ALLERGY_DESCRIPTION",
      column: "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.ALLERGY_DESCRIPTION",
      operator: "=",
      columns: [
        {
          column: "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.ALLERGY_DESCRIPTION",
          key: 'ALLERGY_DESCRIPTION',
          friendlyName: 'Allergy Description',
        },
        {
          column: "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.ALLERGY_CODE",
          key: 'ALLERGY_CODE',
          friendlyName: 'Allergy Code',
        }
      ],
      enableTooltip: true,
      tooltip: {
        definition: definitions.allergy.definition,
        example: definitions.allergy.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.ALLERGY_DESCRIPTION";
          },
          friendlyName: "Allergy",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.ALLERGY_DESCRIPTION",
                },
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.ALLERGY_CODE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Allergy History",
          table: "ALLERGY HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Reaction",
          key: "REACTION_DESCRIPTION",
          column: "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.REACTION_DESCRIPTION",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.64453024205661451",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.REACTION_DESCRIPTION";
              },
              friendlyName: "Reaction",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.REACTION_DESCRIPTION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.ALLERGY_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Patient Demographics",
      table: "PATIENT",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
      friendlyName: "Patient Gender",
      key: "SEX",
      column: "DH_CRC_IUMED.IUMED_DBO_PATIENT.SEX",
      dataType: "TEXT",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.patientDemographics.definition,
        example: definitions.patientDemographics.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_PATIENT.SEX";
          },
          friendlyName: "Patient Gender",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "DH_CRC_IUMED.IUMED_DBO_PATIENT.SEX",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Patient Age",
          key: "PATIENT_AGE",
          column: "DH_CRC_IUMED.IUMED_DBO_PATIENT.PATIENT_AGE",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          isChildFilterNumeric: true,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PATIENT.PATIENT_AGE";
              },
              friendlyName: "Patient Age",
              operators: operators.number,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_PATIENT.PATIENT_AGE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_PATIENT.SEX",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">=",
              operatorLabel: "greater than or equal to",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "NUMBER",
            },
          ],
        },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Marital Status",
          key: "MARITAL_STATUS",
          column: "DH_CRC_IUMED.IUMED_DBO_PATIENT.MARITAL_STATUS",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PATIENT.MARITAL_STATUS";
              },
              friendlyName: "Marital Status",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PATIENT.MARITAL_STATUS",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_PATIENT.SEX",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Ethnicity",
          key: "ETHNICITY",
          column: "DH_CRC_IUMED.IUMED_DBO_PATIENT.ETHNICITY",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PATIENT.ETHNICITY";
              },
              friendlyName: "Ethnicity",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_PATIENT.ETHNICITY",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_PATIENT.SEX",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Race",
          key: "RACE",
          column: "DH_CRC_IUMED.IUMED_DBO_PATIENT.RACE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PATIENT.RACE";
              },
              friendlyName: "Race",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_PATIENT.RACE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_PATIENT.SEX",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Zip Code",
          key: "ZIP_CODE",
          column: "DH_CRC_IUMED.IUMED_DBO_PATIENT.ZIP_CODE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PATIENT.ZIP_CODE";
              },
              friendlyName: "Zip Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_PATIENT.ZIP_CODE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_PATIENT.SEX",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Patient Type",
          key: "PATIENT_TYPE",
          column: "DH_CRC_IUMED.IUMED_DBO_PATIENT.PATIENT_TYPE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PATIENT.PATIENT_TYPE";
              },
              friendlyName: "Patient Type",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_PATIENT.PATIENT_TYPE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_PATIENT.SEX",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    // {
    //   category: "Patient Demographics",
    //   table: "PATIENT",
    //   fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
    //   parentTable: "PATIENT",
    //   friendlyName: "Patient ID",
    //   column: "DH_CRC_IUMED.IUMED_DBO_PATIENT.DATA_CENTER_ID",
    //   //translation takes in array of objects -> friendlyName, operator, showOperator, value
    //   translation: (arr, showOperator, category) => {
    //     if (!showOperator) {
    //       return `${category} with ${arr[0].friendlyName} of ${arr[0].value}`;
    //     }
    //     return `${category} where ${arr[0].friendlyName} ${arr[0].operatorLabel} ${arr[0].value}`;
    //   },
    //   queryBuilderJSON: [
    //     {
    //       id: "r-0.6445302420566821",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_PATIENT.DATA_CENTER_ID";
    //       },
    //       friendlyName: "Patient ID",
    //       operators: (props) => {
    //         if (props && props.dataType === "TEXT") {
    //           return operators.text;
    //         }
    //         return operators.number;
    //       },
    //       distinctValueJSON: (columnValue, phrase = null) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_PATIENT.DATA_CENTER_ID",
    //             }
    //           ],
    //         };
    //       },
    //       showOperator: true,
    //       operator: "=",
    //       operatorLabel: "is",
    //       valueSource: "value",
    //       value: null,
    //       any: false,
    //       dataType: (props) => {
    //         return "NUMBER";
    //       },
    //     },
    //   ],
    // },
    {
      category: "Ejection Fraction",
      table: "EJECTION_FRACTION",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION",
      friendlyName: "Ejection Fraction",
      key: "DISPLAY_NAME",
      column: "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.DISPLAY_NAME",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.ejectionFraction.definition,
        example: definitions.ejectionFraction.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.DISPLAY_NAME";
          },
          friendlyName: "Mode",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.DISPLAY_NAME",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Ejection Fraction",
          table: "EJECTION_FRACTION",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION",
          friendlyName: "EF Value Min",
          key: "EFVALUE_MIN",
          column: "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.EFVALUE_MIN",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.EFVALUE_MIN";
              },
              friendlyName: "EF Min",
              operators: operators.number,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.EFVALUE_MIN",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.DISPLAY_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: false,
              operator: ">=",
              operatorLabel: "greater than or equal to",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "NUMBER",
            },
          ],
        },
        {
          category: "Ejection Fraction",
          table: "EJECTION_FRACTION",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION",
          friendlyName: "EF Value Max",
          key: "EFVALUE_MAX",
          column: "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.EFVALUE_MAX",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.EFVALUE_MAX";
              },
              friendlyName: "EF Max",
              operators: operators.number,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.EFVALUE_MAX",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.DISPLAY_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: false,
              operator: "<=",
              operatorLabel: "greater than or equal to",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "NUMBER",
            },
          ],
        },
        {
          category: "Ejection Fraction",
          table: "EJECTION_FRACTION",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION",
          friendlyName: "Study Date",
          key: "STUDY_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.STUDY_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.STUDY_DATE";
              },
              friendlyName: "Study Date",
              operators: operators.number,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.STUDY_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_EJECTION_FRACTION.DISPLAY_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: false,
              operator: "<=",
              operatorLabel: "greater than or equal to",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Lab Tests",
      table: "LAB_RESULT",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT",
      parentTable: "PATIENT",
      friendlyName: "Lab Description",
      key: "OBSERVATION_DESCRIPTION",
      column: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.OBSERVATION_DESCRIPTION",
      operator: "=",
      hasEndingLabel: true,
      endingLabelKey: "UOF_M",
      props: [],
      isChildFilterNumeric: false,
      enableTooltip: true,
      tooltip: {
        definition: definitions.labResult.definition,
        example: definitions.labResult.example,
      },
      columns: [
        {
          column: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.OBSERVATION_DESCRIPTION",
          key: 'OBSERVATION_DESCRIPTION',
          friendlyName: 'Observation Description',
        },
        {
          column: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.OBSERVATION_CODE",
          key: 'OBSERVATION_CODE',
          friendlyName: 'Observation Code',
        },
        // {
        //   column: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.RESULT_TYPE",
        //   key: 'RESULT_TYPE',
        //   friendlyName: 'Result Type',
        // },
        // {
        //   column: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.UOF_M",
        //   key: 'UOF_M',
        //   friendlyName: 'Unit Of Measure',
        // },
        // {
        //   column: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.NORMAL_RANGE",
        //   key: 'NORMAL_RANGE',
        //   friendlyName: 'Normal Range',
        // }
      ],
      queryBuilderJSON: [
        {
          id: "r-0.64453130566821",
          field: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.OBSERVATION_DESCRIPTION",
          friendlyName: "Lab Observation",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.OBSERVATION_DESCRIPTION",
                },
                {
                  columnName: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.OBSERVATION_CODE",
                },
                // {
                //   columnName: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.RESULT_TYPE",
                // },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT",
          parentTable: "PATIENT",
          friendlyName: "Unit of Measure",
          key: "UOF_M",
          column: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.UOF_M",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.UOF_M";
              },
              friendlyName: "Unit of Measure",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.UOF_M",
                    }
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.OBSERVATION_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT"
            }
          ],
        },
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT",
          parentTable: "PATIENT",
          friendlyName: "Normal Range",
          key: "NORMAL_RANGE",
          column: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.NORMAL_RANGE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.NORMAL_RANGE";
              },
              friendlyName: "Normal Range",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.NORMAL_RANGE",
                    }
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.OBSERVATION_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT"
            }
          ],
        },
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT",
          parentTable: "PATIENT",
          friendlyName: "Lab Text Value",
          key: "TEXT_VALUE",
          column: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.TEXT_VALUE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.TEXT_VALUE",
              friendlyName: "Lab Value",
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: false, //settings this to false, please see below
                  autoCompletePhrase: null, //this is set to null because otherwise it will search those 3 columns which we don't want
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.TEXT_VALUE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.OBSERVATION_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataTypeColumn: "RESULT_TYPE",
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT",
          parentTable: "PATIENT",
          friendlyName: "Lab Numeric Value",
          key: "NUMERIC_VALUE",
          column: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.NUMERIC_VALUE",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.NUMERIC_VALUE",
              friendlyName: "Lab Value",
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: false, //settings this to false, please see below
                  autoCompletePhrase: null, //this is set to null because otherwise it will search those 3 columns which we don't want
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.NUMERIC_VALUE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_LAB_RESULT.OBSERVATION_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataTypeColumn: "RESULT_TYPE",
              dataType: "NUMBER",
            },
          ],
        },
      ],
    },
    {
      category: "Chief Complaint History",
      table: "CHIEF_COMPLAINT_HISTORY",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_CHIEF_COMPLAINT_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Chief Complaint",
      key: "COMPLAINT",
      column: "DH_CRC_IUMED.IUMED_DBO_CHIEF_COMPLAINT_HISTORY.COMPLAINT",
      operator: "=",
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.chiefComplaint.definition,
        example: definitions.chiefComplaint.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_CHIEF_COMPLAINT_HISTORY.COMPLAINT";
          },
          friendlyName: "Chief Complaint",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_CHIEF_COMPLAINT_HISTORY.COMPLAINT",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Chief Complaint History",
          table: "CHIEF_COMPLAINT_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_CHIEF_COMPLAINT_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Reported Date",
          key: "REPORTED_DATE",
          column:
            "DH_CRC_IUMED.IUMED_DBO_CHIEF_COMPLAINT_HISTORY.REPORTED_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.REPORTED_DATE";
              },
              friendlyName: "Reported Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_ALLERGY_HISTORY.REPORTED_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_CHIEF_COMPLAINT_HISTORY.COMPLAINT",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Diagnosis History",
      table: "DIAGNOSIS_HISTORY",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Diagnosis Description",
      key: "DIAGNOSIS_DESCRIPTION",
      column: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DESCRIPTION",
      operator: "=",
      columns: [
        {
          column: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DESCRIPTION",
          key: 'DIAGNOSIS_DESCRIPTION',
          friendlyName: 'Diagnosis Description',
        },
        {
          column: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_CODE",
          key: 'DIAGNOSIS_CODE',
          friendlyName: 'Diagnosis Code',
        }
      ],
      enableTooltip: true,
      tooltip: {
        definition: definitions.diagnosisHistory.definition,
        example: definitions.diagnosisHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DESCRIPTION";
          },
          friendlyName: "Diagnosis Description",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DESCRIPTION",
                },
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_CODE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Diagnosis Code System",
          key: "DIAGNOSIS_CODE_SYSTEM",
          column:
            "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_CODE_SYSTEM",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_CODE_SYSTEM";
              },
              friendlyName: "Diagnosis Code System",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_CODE_SYSTEM",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Diagnosis Code",
          key: "DIAGNOSIS_CODE",
          column: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_CODE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_CODE";
              },
              friendlyName: "Diagnosis Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_CODE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Diagnosis Status",
          key: "DIAGNOSIS_STATUS",
          column: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_STATUS",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_STATUS";
              },
              friendlyName: "Diagnosis Status",
              operators: operators.text,

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_STATUS",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: "",
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "DIAGNOSIS_STATUS",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Reported Date",
          key: "REPORTED_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.REPORTED_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.REPORTED_DATE";
              },
              friendlyName: "Reported Date",
              operators: operators.text,

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.REPORTED_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: "",
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "REPORTED_DATE",
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Diagnosis Date",
          key: "DIAGNOSIS_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DATE";
              },
              friendlyName: "Diagnosis Date",
              operators: operators.text,

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: "",
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "DIAGNOSIS_DATE",
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Diagnosis Snowmed Code Description",
          key: "DIAGNOSIS_SNOMED_CODE_DESCRIPTION",
          column:
            "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_SNOMED_CODE_DESCRIPTION",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_SNOMED_CODE_DESCRIPTION";
              },
              friendlyName: "Diagnosis Status",
              operators: operators.text,

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_SNOMED_CODE_DESCRIPTION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_DIAGNOSIS_HISTORY.DIAGNOSIS_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: "",
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "DIAGNOSIS_SNOMED_CODE_DESCRIPTION",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "DRM Data",
      table: "DRMDATA",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
      parentTable: "PATIENT",
      friendlyName: "Report Name",
      key: "REPORT_NAME",
      column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME";
          },
          friendlyName: "Report Name",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "DRM Data",
          table: "DRMDATA",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
          parentTable: "PATIENT",
          friendlyName: "Data Category",
          key: "DATA_CATEGORY",
          column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY";
              },
              friendlyName: "Report Name",
              operators: operators.text,
              parentField: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "DATA_CATEGORY",
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "DRM Data",
          table: "DRMDATA",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
          parentTable: "PATIENT",
          friendlyName: "Report Date",
          key: "REPORT_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE";
              },
              friendlyName: "Report Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "DRM Data",
          table: "DRMDATA",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
          parentTable: "PATIENT",
          friendlyName: "Study Date",
          key: "STUDY_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE";
              },
              friendlyName: "Study Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    // {
    //   category: "DRM Data",
    //   table: "DRMDATA",
    //   fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
    //   parentTable: "PATIENT",
    //   friendlyName: "Field Value",
    //   key: "FIELD_VALUE",
    //   column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.FIELD_VALUE",
    //   translation: (arr, showOperator, category) => {
    //     if (!showOperator) {
    //       return `${category} with ${arr[0].friendlyName} of ${arr[0].value}`;
    //     }
    //     return `${category} where ${arr[0].friendlyName} ${arr[0].operatorLabel} ${arr[0].value}`;
    //   },
    //   queryBuilderJSON: [
    //     {
    //       id: "r-0.6445302420566821",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME";
    //       },
    //       friendlyName: "Report Name",
    //       operators: operators.text,
    //       distinctValueJSON: (columnValue, phrase = null) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
    //             }
    //           ],
    //         };
    //       },
    //       showOperator: true,
    //       operator: "=",
    //       operatorLabel: "is",
    //       valueSource: "value",
    //       value: null,
    //       selectOptions: [],
    //       displayType: null,
    //       rowCount: 0,
    //       any: null,
    //       dataType: (props) => {
    //         return "TEXT";
    //       },
    //     },
    //     {
    //       id: "r-0.6445302420566821",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY";
    //       },
    //       friendlyName: "Category",
    //       operators: operators.text,
    //       parentField: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
    //
    //       distinctValueJSON: (columnValue, phrase) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
    //             },
    //           ],
    //           wheres: {
    //             id: "g-0.8517528779532519",
    //             rules: [
    //               {
    //                 id: "r-0.6445302420566821",
    //                 field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
    //                 operator: "=",
    //                 valueSource: "value",
    //                 value: columnValue,
    //                 dataType: "TEXT",
    //               },
    //             ],
    //             combinator: "and",
    //             not: false,
    //           },
    //         };
    //       },
    //       showOperator: true,
    //       operator: "=",
    //       operatorLabel: "is",
    //       valueSource: "value",
    //       value: null,
    //       selectOptions: [],
    //       displayType: null,
    //       rowCount: 0,
    //       selectOptionsColumn: "DATA_CATEGORY",
    //       any: null,
    //       dataType: (props) => {
    //         return "TEXT";
    //       },
    //     },
    //     {
    //       id: "r-0.6445302420566821",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.FIELD_NAME";
    //       },
    //       friendlyName: "Field Name",
    //       operators: operators.text,
    //       parentField: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
    //
    //       distinctValueJSON: (columnValue, phrase) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.FIELD_NAME",
    //             },
    //           ],
    //           wheres: {
    //             id: "g-0.8517528779532519",
    //             rules: [
    //               {
    //                 id: "r-0.6445302420566821",
    //                 field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
    //                 operator: "=",
    //                 valueSource: "value",
    //                 value: columnValue,
    //                 dataType: "TEXT",
    //               },
    //             ],
    //             combinator: "and",
    //             not: false,
    //           },
    //         };
    //       },
    //       showOperator: true,
    //       operator: "=",
    //       operatorLabel: "is",
    //       valueSource: "value",
    //       value: null,
    //       selectOptions: [],
    //       displayType: null,
    //       rowCount: 0,
    //       selectOptionsColumn: "FIELD_NAME",
    //       any: false,
    //       dataType: (props) => {
    //         return "TEXT";
    //       },
    //     },
    //     {
    //       id: "r-0.6445302420566551",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE";
    //       },
    //       friendlyName: "Study Date",
    //       operators: operators.date,
    //       distinctValueJSON: (columnValue, phrase = null) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE",
    //             }
    //           ],
    //         };
    //       },
    //       showOperator: true,
    //       operator: ">",
    //       operatorLabel: "greater than",
    //       valueSource: "value",
    //       value: null,
    //       dataType: (props) => {
    //         return "DATE";
    //       },
    //     },
    //     {
    //       id: "r-0.6445302420566551",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE";
    //       },
    //       friendlyName: "Report Date",
    //       operators: operators.date,
    //       distinctValueJSON: (columnValue, phrase = null) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE",
    //             }
    //           ],
    //         };
    //       },
    //       showOperator: true,
    //       operator: ">",
    //       operatorLabel: "greater than",
    //       valueSource: "value",
    //       value: null,
    //       dataType: (props) => {
    //         return "DATE";
    //       },
    //     },
    //   ],
    // },
    {
      category: "Family History",
      table: "FAMILY_HISTORY",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Family Member",
      key: "FAMILY_MEMBER",
      column: "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_MEMBER",
      operator: "=",
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.familyHistory.definition,
        example: definitions.familyHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_MEMBER";
          },
          friendlyName: "Family Member",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_MEMBER",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Family History",
          table: "FAMILY_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENTRY_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.ENTRY_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.ENTRY_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.ENTRY_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_MEMBER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Family History",
          table: "FAMILY_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Family Member Sex",
          key: "FAMILY_MEMBER_SEX",
          column: "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_MEMBER_SEX",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_MEMBER_SEX";
              },
              friendlyName: "Family Member Sex",
              operators: operators.text,
              parentField:
                "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_MEMBER",

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_MEMBER_SEX",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_MEMBER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "FAMILY_MEMBER_SEX",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Family History",
          table: "FAMILY_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Family History Problem",
          key: "FAMILY_HISTORY_PROBLEM",
          column:
            "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_HISTORY_PROBLEM",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_HISTORY_PROBLEM";
              },
              friendlyName: "Family Member Sex",
              operators: operators.text,
              parentField:
                "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_HISTORY_PROBLEM",

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_HISTORY_PROBLEM",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.FAMILY_MEMBER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "FAMILY_MEMBER_SEX",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Medical Order History",
      table: "MEDICAL_ORDER_HISTORY",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Order Name",
      key: "ORDER_NAME",
      column: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.ORDER_NAME",
      operator: ">",
      columns: [
        {
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.ORDER_NAME",
          key: 'ORDER_NAME',
          friendlyName: 'Order Name',
        },
        {
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.ORDER_CODE",
          key: 'ORDER_CODE',
          friendlyName: 'Order Code',
        },
        {
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.CODE_SYSTEM",
          key: 'CODE_SYSTEM',
          friendlyName: 'Code System',
        }
      ],
      enableTooltip: true,
      tooltip: {
        definition: definitions.medicalOrderHistory.definition,
        example: definitions.medicalOrderHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.ORDER_NAME";
          },
          friendlyName: "Order Code",
          operators: operators.text,

          distinctValueJSON: (columnValue, phrase) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.ORDER_NAME",
                },
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.ORDER_CODE",
                },
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.CODE_SYSTEM",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          selectOptionsColumn: "ORDER_NAME",
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Medical Order History",
          table: "MEDICAL_ORDER_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Code System",
          key: "CODE_SYSTEM",
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.CODE_SYSTEM",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.CODE_SYSTEM";
              },
              friendlyName: "Code System",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.CODE_SYSTEM",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.ORDER_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medical Order History",
          table: "MEDICAL_ORDER_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Department",
          key: "DEPARTMENT",
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.DEPARTMENT",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.DEPARTMENT";
              },
              friendlyName: "Department",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.DEPARTMENT",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.ORDER_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medical Order History",
          table: "MEDICAL_ORDER_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Diagnosis Code",
          key: "DIAGNOSIS_CODE",
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.DIAGNOSIS_CODE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.DIAGNOSIS_CODE";
              },
              friendlyName: "Diagnosis Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.DIAGNOSIS_CODE",
                    },
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.DIAGNOSIS_DESCRIPTION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.ORDER_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medical Order History",
          table: "MEDICAL_ORDER_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Completed Date",
          key: "COMPLETED_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.COMPLETED_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.COMPLETED_DATE";
              },
              friendlyName: "Completed Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.COMPLETED_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.ORDER_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Medical Order History",
          table: "MEDICAL_ORDER_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENTRY_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICAL_ORDER_HISTORY.ENTRY_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.ENTRY_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_FAMILY_HISTORY.ENTRY_DATE",
                    },
                  ],
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Medication History",
      table: "MEDICATION_NAME",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Medication Name",
      key: "MEDICATION_NAME",
      column: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_NAME",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.medicationHistory.definition,
        example: definitions.medicationHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_NAME";
          },
          friendlyName: "Medication Name",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_NAME",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          selectOptionsColumn: "MEDICATION_NAME",
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Medication Code System",
          key: "MEDICATION_CODE_SYSTEM",
          column:
            "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_CODE_SYSTEM",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_CODE_SYSTEM";
              },
              friendlyName: "Code System",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_CODE_SYSTEM",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Medication Code",
          key: "MEDICATION_CODE",
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_CODE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_CODE";
              },
              friendlyName: "Medication Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_CODE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "MEDICATION_CODE",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Medication Strength",
          key: "STRENGTH",
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.STRENGTH",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.STRENGTH";
              },
              friendlyName: "Medication Strength",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.STRENGTH",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                  orderBys: [
                    {
                      column:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.STRENGTH",
                      direction: "asc",
                    },
                  ],
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              selectOptionsColumn: "STRENGTH",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Route Of Administration",
          key: "ROUTE_OF_ADMINISTRATION",
          column:
            "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.ROUTE_OF_ADMINISTRATION",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.ROUTE_OF_ADMINISTRATION";
              },
              friendlyName: "Route of Administration",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.ROUTE_OF_ADMINISTRATION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Form",
          key: "FORM",
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.FORM",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.FORM";
              },
              friendlyName: "Form",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.FORM",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Is Active",
          key: "IS_ACTIVE",
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.IS_ACTIVE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 4,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.IS_ACTIVE";
              },
              friendlyName: "Is Active",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.IS_ACTIVE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: false,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Start Date",
          key: "MEDICATION_START_DATE",
          column:
            "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_START_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_START_DATE";
              },
              friendlyName: "Start Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_START_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">=",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Stop Date",
          key: "STOP_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.STOP_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.STOP_DATE";
              },
              friendlyName: "Stop Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.STOP_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_MEDICATION_HISTORY.MEDICATION_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "<=",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Past Medical History",
      table: "PAST_MEDICAL_HISTORY",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Past Medical Answer",
      key: "QUESTION_TEXT",
      column: "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.QUESTION_TEXT",
      operator: "=",
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.pastMedicalHistory.definition,
        example: definitions.pastMedicalHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.QUESTION_TEXT";
          },
          friendlyName: "Question",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.QUESTION_TEXT",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Past Medical History",
          table: "PAST_MEDICAL_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENTRY_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.ENTRY_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.ENTRY_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.ENTRY_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.QUESTION_TEXT",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Past Medical History",
          table: "PAST_MEDICAL_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Answer Text",
          key: "ANSWER_TEXT",
          column: "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.ANSWER_TEXT",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.ANSWER_TEXT";
              },
              friendlyName: "Answer Text",
              operators: operators.text,
              parentField:
                "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.QUESTION_TEXT",

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.ANSWER_TEXT",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_PAST_MEDICAL_HISTORY.QUESTION_TEXT",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "ANSWER_TEXT",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Procedure History",
      table: "PROCEDURE_HISTORY",
      fullTableName: "DH_CRC_IUMED.CRC_IUMED_F_PROCEDURE",
      parentTable: "PATIENT",
      friendlyName: "Procedure",
      key: "PROCEDURE_CODE",
      column: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE",
      operator: "=",
      columns: [
        {
          column: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE",
          key: 'PROCEDURE_CODE',
          friendlyName: 'Procedure Code',
        },
        {
          column: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_DESCRIPTION",
          key: 'PROCEDURE_DESCRIPTION',
          friendlyName: 'Procedure Description',
        }
      ],
      enableTooltip: true,
      tooltip: {
        definition: definitions.procedureHistory.definition,
        example: definitions.procedureHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE";
          },
          friendlyName: "Procedure Description",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE",
                },
                {
                  columnName: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_DESCRIPTION",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          selectOptionsColumn: "PROCEDURE_DESCRIPTION",
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Procedure History",
          table: "PROCEDURE_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Procedure Date",
          key: "PROCEDURE_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_DATE";
              },
              friendlyName: "Procedure Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Procedure History",
          table: "PROCEDURE_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENTRY_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.ENTRY_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.ENTRY_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.ENTRY_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Procedure History",
          table: "PROCEDURE_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Procedure Code System",
          key: "PROCEDURE_CODE_SYSTEM",
          column:
            "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE_SYSTEM",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE_SYSTEM";
              },
              friendlyName: "Procedure Code System",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE_SYSTEM",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Procedure History",
          table: "PROCEDURE_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Primary Diagnosis Code",
          key: "PRIMARY_DIAGNOSIS_CODE",
          column:
            "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PRIMARY_DIAGNOSIS_CODE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PRIMARY_DIAGNOSIS_CODE";
              },
              friendlyName: "Primary Diagnosis Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PRIMARY_DIAGNOSIS_CODE",
                    },
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PRIMARY_DIAGNOSIS_DESCRIPTION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Procedure History",
          table: "PROCEDURE_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Secondary Diagnosis Code",
          column:
            "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.SECONDARY_DIAGNOSIS_CODE",
          key: "SECONDARY_DIAGNOSIS_CODE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.SECONDARY_DIAGNOSIS_CODE";
              },
              friendlyName: "Secondary Diagnosis Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.SECONDARY_DIAGNOSIS_CODE",
                    },
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.SECONDARY_DIAGNOSIS_DESCRIPTION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: true,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Procedure History",
          table: "PROCEDURE_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Tertiary Diagnosis Code",
          column:
            "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.TERTIARY_DIAGNOSIS_CODE",
          key: "TERTIARY_DIAGNOSIS_CODE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.TERTIARY_DIAGNOSIS_CODE";
              },
              friendlyName: "Tertiary Diagnosis Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.TERTIARY_DIAGNOSIS_CODE",
                    },
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.TERTIARY_DIAGNOSIS_DESCRIPTION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: true,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Procedure History",
          table: "PROCEDURE_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Quaternary Diagnosis Code",
          key: "QUATERNARY_DIAGNOSIS_CODE",
          column:
            "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.QUATERNARY_DIAGNOSIS_CODE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.QUATERNARY_DIAGNOSIS_CODE";
              },
              friendlyName: "Quaternary Diagnosis Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.QUATERNARY_DIAGNOSIS_CODE",
                    },
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.QUATERNARY_DIAGNOSIS_DESCRIPTION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_PROCEDURE_HISTORY.PROCEDURE_CODE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: true,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Review of System",
      table: "REVIEW_OF_SYSTEM",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM",
      parentTable: "PATIENT",
      friendlyName: "Review of System Question",
      key: "QUESTION_TEXT",
      column: "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM.QUESTION_TEXT",
      operator: "=",
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.reviewOfSystems.definition,
        example: definitions.reviewOfSystems.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM.QUESTION_TEXT";
          },
          friendlyName: "Question",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM.QUESTION_TEXT",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Review of System",
          table: "REVIEW_OF_SYSTEM",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENTRY_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM.ENTRY_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM.ENTRY_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM.ENTRY_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM.QUESTION_TEXT",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Review of System",
          table: "REVIEW_OF_SYSTEM",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM",
          parentTable: "PATIENT",
          friendlyName: "Review of System Question",
          key: "ANSWER_TEXT",
          column: "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM.ANSWER_TEXT",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM.ANSWER_TEXT";
              },
              friendlyName: "Answer",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM.ANSWER_TEXT",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_REVIEW_OF_SYSTEM.QUESTION_TEXT",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "ANSWER_TEXT",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Social History",
      table: "SOCIAL_HISTORY",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Social History Question",
      key: "QUESTION_TEXT",
      column: "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY.QUESTION_TEXT",
      operator: "=",
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.socialHistory.definition,
        example: definitions.socialHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY.QUESTION_TEXT";
          },
          friendlyName: "Question",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY.QUESTION_TEXT",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Social History",
          table: "SOCIAL_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENTRY_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY.ENTRY_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY.ENTRY_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY.ENTRY_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY.QUESTION_TEXT",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Social History",
          table: "SOCIAL_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Social History Answer",
          key: "ANSWER_TEXT",
          column: "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY.ANSWER_TEXT",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY.ANSWER_TEXT";
              },
              friendlyName: "Answer",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY.ANSWER_TEXT",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_SOCIAL_HISTORY.QUESTION_TEXT",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "ANSWER_TEXT",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Stroke Risk Score",
      table: "STROKE_RISK_SCORE",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE",
      parentTable: "PATIENT",
      friendlyName: "Stroke Risk Score",
      key: "RISK_PROGRAM",
      column: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_PROGRAM",
      operator: "=",
      enableTooltip: false,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_PROGRAM";
          },
          friendlyName: "Risk Program",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_PROGRAM",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Stroke Risk Score",
          table: "STROKE_RISK_SCORE",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "SCORE_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.SCORE_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.SCORE_DATE";
              },
              friendlyName: "Score Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.SCORE_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_PROGRAM",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Stroke Risk Score",
          table: "STROKE_RISK_SCORE",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE",
          parentTable: "PATIENT",
          friendlyName: "Risk Score",
          key: "RISK_SCORE",
          column: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_SCORE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_SCORE";
              },
              friendlyName: "Score",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_SCORE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_PROGRAM",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Vital Sign History",
      table: "VITAL_SIGN_HISTORY",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Vital Sign Description",
      key: "VITAL_SIGN_DESCRIPTION",
      column:
        "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_DESCRIPTION",
      operator: "=",
      hasEndingLabel: true,
      endingLabelKey: "UNIT_OF_MEASURE",
      hiddenColumns: {
        VITAL_SIGN_DESCRIPTION: true,
        UNIT_OF_MEASURE: false,
        PATIENTCOUNT: true,
      },
      columns: [
        {
          column: "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_DESCRIPTION",
          key: 'VITAL_SIGN_DESCRIPTION',
          friendlyName: 'Vital Sign Description',
        },
        {
          column: "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.UNIT_OF_MEASURE",
          key: 'UNIT_OF_MEASURE',
          friendlyName: 'Unit Of Measure',
        }
      ],
      enableTooltip: true,
      tooltip: {
        definition: definitions.vitalSignHistory.definition,
        example: definitions.vitalSignHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_DESCRIPTION";
          },
          friendlyName: "Vital Sign Description",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_DESCRIPTION",
                },
                {
                  columnName:
                    "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.UNIT_OF_MEASURE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Vital Sign History",
          table: "VITAL_SIGN_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Measure Date",
          key: "MEASURE_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.MEASURE_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.MEASURE_DATE";
              },
              friendlyName: "Measure Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.MEASURE_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Vital Sign History",
          table: "VITAL_SIGN_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Vital Sign Value",
          key: "VITAL_SIGN_NUMERIC_VALUE",
          column:
            "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_NUMERIC_VALUE",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field:
                "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_NUMERIC_VALUE",
              friendlyName: "Vital Sign Value",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_NUMERIC_VALUE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "NUMBER",
            },
          ],
        },
        {
          category: "Vital Sign History",
          table: "VITAL_SIGN_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Vital Sign Code System",
          key: "VITAL_SIGN_CODE_SYSTEM",
          column:
            "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.VITAL_SIGN_CODE_SYSTEM",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field:
                "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_CODE_SYSTEM",
              friendlyName: "Vital Sign Code System",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_CODE_SYSTEM",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Vital Sign History",
          table: "VITAL_SIGN_HISTORY",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Vital Sign Code",
          key: "VITAL_SIGN_CODE",
          column: "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_CODE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field:
                "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_CODE",
              friendlyName: "Vital Sign Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_CODE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "DH_CRC_IUMED.IUMED_DBO_VITAL_SIGN_HISTORY.VITAL_SIGN_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "VITAL_SIGN_CODE",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Documents",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "Documents",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC CHF Registry",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC CHF Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC AFIB Registry",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC AFIB Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC PCI Registry",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC PCI Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC MI Registry",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC MI Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC EP Registry",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC EP Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
  ],
};

export default data;
